import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import * as mmTagsApi from '../api/measurement_meta_tags';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { translate } from '../i18n_text';
import { canCreateTraitTag, canDeleteTraitTag, reactListTablesEnabled } from '../permissions';
import { session } from '../session';
import { GridView } from '../utils/grid_view';
import { TraitTagsListPage, TraitTagsListProps, TraitTagsListQuery, TraitTagsListRow } from 'react-islands';

const template = require('raw-loader!../../templates/measurement_meta_tags.html').default;

class MeasurementMetaTagsScreen implements ListLoaderDelegate<mmTagsApi.MeasurementMetaTagData> {
  canCreate = canCreateTraitTag();
  canDelete = canDeleteTraitTag();
  listActions = ko.observableArray<ListHeaderAction>([]);

  newTraitTagsTable = reactListTablesEnabled();

  private view = new GridView('trait-tags');

  tableProps = ko.pureComputed<TraitTagsListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
  }));

  constructor(params: { filters: unknown }) {
    if (this.canCreate) {
      this.listActions.push({
        title: i18n.t('Add')(),
        icon: 'add_circle',
        href: '/trait_tags/new/',
        tooltipTitle: i18n.t('Add Trait Tag')(),
      });
    }

    if (this.newTraitTagsTable) {
      this.view.load(params.filters);
    }
  }

  fetch(params: ListRequestParams) {
    return mmTagsApi.list(params);
  }

  instantiate(data: mmTagsApi.MeasurementMetaTagData) {
    return data;
  }

  remove(id: string) {
    return mmTagsApi.remove(id);
  }

  canRemove(data: mmTagsApi.MeasurementMetaTagData) {
    return this.canDelete;
  }

  private fetchPage = (query: TraitTagsListQuery): Promise<TraitTagsListPage> =>
    this.view.fetchListPage(query, mmTagsApi.list, 'name_prefix', this);

  toRow = (tag: mmTagsApi.MeasurementMetaTagData): TraitTagsListRow => ({
    id: tag.id,
    name: translate(tag.name_json),
    url: session.toTenantPath(this.editPath(tag)),
    actions: delegateActions(this, tag, this.view.reload),
  });

  private editPath(tag: mmTagsApi.MeasurementMetaTagData): string {
    return '/trait_tags/' + tag.id + '/';
  }
}

export const measurementMetaTags = {
  name: 'measurement-meta-tags',
  viewModel: MeasurementMetaTagsScreen,
  template,
};

ko.components.register(measurementMetaTags.name, measurementMetaTags);
